<template>
    <!-- COMPANY_CLASS_MODAL -->
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template #body>
            <div class="search-wrap">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <ElLabel name="리비전">
                      <template #end="{id}">
                        <ElInput
                          :id="id"
                          :modelValue="maxRv"
                          @update:modelValue="r=>maxRv = r"
                          readonly
                        />
                      </template>
                    </ElLabel>


                  </div>
                </div>
              </div>
            </div>
            <div class="search-detail-wrap"></div>

            <div class="text-end py-2">
              <ElButton type="search" @buttonClick="getDataList()">검색</ElButton>
            </div>

            <div class="table-responsive table-list">
              <!--grid 영역-->
              <TreeTable
                    ref="treeTableRef"
                    v-bind="treeGridProps"
                />
            </div>
        </template>
    </BaseModal>


</template>

<script setup>
import { reactive,ref,onBeforeMount, watch } from 'vue';
import BaseModal from '@/components/common/modal/BaseModal.vue';
import { useLoading } from '@/composable/Loading.js'
import TreeTable from '../TreeTable.vue';
import { getRevIdList,classHisList } from '@/api/comp';

const { setIsLoading } = useLoading()
const baseModalRef = ref()
const treeTableRef = ref()
const emits = defineEmits(['return'])

const childProps = ref({
    modalId : 'cmpClassModal',
    modalNm : '회사분류',
    size:'lg',
    btnList : [
        {name : '선택' , classNm : 'search', function : selectData}
    ]
})

const maxRv = ref('')
const cmpClsList = ref([])

//그리드 속성값 정의
const treeGridProps = ref({
    gridColumn : [
        { header: '이름', field: 'class_nm', expander: true, style: { minWidth: '250px' } },
        { header: '활성화여부', field: "enable_yn", style: { minWidth: '250px' } },
        { header: '메모', field: "note", style: { minWidth: '250px' } }
  ],
    dataList : [],
    editable :false,
    rootVal : '',
    useCheckBox : false,
    selectType : 'single',

})
const state = reactive({
  isOpen:false
})


watch(() => state.isOpen, async (newValue, oldValue) => {
  if(newValue){
    await fetchRevIdList()
    await getDataList()
  }
})

function openModal(){
    baseModalRef.value.openModal()
    state.isOpen = true
}

function closeModal(){
    baseModalRef.value.closeModal()
    state.isOpen = false
}

async function fetchRevIdList(){
  try {
    setIsLoading(true)
    const res = await getRevIdList()
    for (let i of res.rtn) {
      if (maxRv.value < i.rev_id) {
        maxRv.value = i.rev_id
      }
    }
  } catch (err) {
    console.error(err)
    alert('회사분류 정보를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}



async function getDataList(){
  let params = {
    rev_id: maxRv.value
  }

  try {
    setIsLoading(true)
    const res = await classHisList(params)
    cmpClsList.value = [...res.rtn]
    treeGridProps.value.dataList = [...res.rtn];
  } catch (err) {
    alert("조회 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
};

function selectData(){
    closeModal()
    let returnData = {
        classId :Object.keys(treeTableRef.value.selectionKeys)[0],
        revId : maxRv.value
    }
    emits('return',returnData)
    
}

defineExpose({
    openModal,
    cmpClsList
})



</script>